import React from 'react';
import { Link } from 'react-router-dom';
import colors from '../colors';

function Privacy() {
    return (
        <div style={styles.pageWrapper}>
            <div style={styles.topBar}>
                <Link to="/" style={styles.backButton}>← Back</Link>
            </div>
            <div style={styles.container}>
                <h1>Privacy Policy</h1>
                <p>At Wisemoji, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our Website.</p>

                <h3>1. Information We Collect</h3>
                <p><strong>Personal Information:</strong> Such as your name, email address, and any other information you voluntarily provide when contacting us.</p>
                <p><strong>Non-Personal Information:</strong> Including but not limited to IP addresses, browser types, and pages viewed.</p>

                <h3>2. How We Use Your Information</h3>
                <p><strong>To Improve Our Services:</strong> Analyze usage to enhance user experience.</p>
                <p><strong>Communication:</strong> Respond to inquiries and send updates.</p>

                <h3>3. Cookies and Tracking Technologies</h3>
                <p>We use cookies to collect information about your interactions with our Website to improve our services.</p>
                <p><strong>Managing Cookies:</strong> You can disable cookies through your browser settings, but this may affect the functionality of the Website.</p>

                <h3>4. Data Sharing and Disclosure</h3>
                <p><strong>Third-Party Service Providers:</strong> We may share your information with third parties who assist us in operating the Website.</p>
                <p><strong>Legal Requirements:</strong> We may disclose your information if required by law.</p>

                <h3>5. Data Security</h3>
                <p>We implement reasonable security measures to protect your personal information from unauthorized access, alteration, or disclosure.</p>

                <h3>6. User Rights</h3>
                <p><strong>Access and Correction:</strong> You have the right to request access to or correction of your personal data.</p>
                <p><strong>Deletion:</strong> You may request the deletion of your personal data, subject to legal obligations.</p>

                <h3>7. Third-Party Links</h3>
                <p>Our Website may contain links to external sites not operated by us. We have no control over the content and practices of these sites.</p>

                <h3>8. Children's Privacy</h3>
                <p>Our Website is not intended for individuals under the age of 18. We do not knowingly collect personal information from minors.</p>

                <h3>9. Changes to This Privacy Policy</h3>
                <p>We may update our Privacy Policy from time to time. Changes will be posted on this page with an updated revision date.</p>
            </div>
        </div>
    );
}

const styles = {
    pageWrapper: {
        backgroundColor: colors.primaryDark,
        minHeight: '100vh',
        padding: '20px',
    },
    topBar: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '20px',
    },
    backButton: {
        backgroundColor: colors.primaryDark,
        color: colors.textLight,
        padding: '10px 20px',
        borderRadius: '5px',
        fontSize: '1rem',
        textDecoration: 'none',
        cursor: 'pointer',
    },
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: 'Press Start 2P, cursive',
        lineHeight: '1.6',
        color: colors.textLight,
    },
};

export default Privacy;